const dark_theme = JSON.parse(localStorage.getItem("@socialcam/theme"))
const state = () => ({
  theme: dark_theme !== undefined && dark_theme !== null ? dark_theme : true,
});

const getters = {
  getTheme: state => {
    return state.theme;
  },
};

const actions = {
  async setUserTheme({ commit }, payload) {
    const { dark_theme } = payload
    try {
      commit("setUserTheme", dark_theme);

    } catch (error) {
      return error
    }
  },
};

const mutations = {
  setUserTheme(state, payload) {
    state.theme = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
